"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var _require = require("awesome-phonenumber"),
  parsePhoneNumber = _require.parsePhoneNumber;
var BaseStringHandler = require("../BaseStringHandler/index.js");
var E164PhoneHandler = /*#__PURE__*/function (_BaseStringHandler) {
  function E164PhoneHandler() {
    var _this;
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck2["default"])(this, E164PhoneHandler);
    _this = _callSuper(this, E164PhoneHandler);
    var country = config.country;
    _this.country = country || "US";
    return _this;
  }
  (0, _inherits2["default"])(E164PhoneHandler, _BaseStringHandler);
  return (0, _createClass2["default"])(E164PhoneHandler, [{
    key: "validate",
    value: function validate(phone) {
      var regEx = /^\+[1-9]\d{1,14}$/;
      return regEx.test(phone);
    }
  }, {
    key: "format",
    value: function format(phone) {
      var _result$number;
      var phoneStartsWithCode = phone.startsWith("+");
      var result = parsePhoneNumber(phone, phoneStartsWithCode ? null : {
        regionCode: this.country
      });
      var e164Formatted = result === null || result === void 0 || (_result$number = result.number) === null || _result$number === void 0 ? void 0 : _result$number.e164;
      if (!e164Formatted || !result.valid) {
        throw new Error("Invalid E164 phone number");
      }
      return e164Formatted;
    }
  }]);
}(BaseStringHandler);
module.exports = E164PhoneHandler;